// extracted by mini-css-extract-plugin
module.exports = {"container":"featured-carousel_container__213wN","item":"featured-carousel_item__36Rjk","buttonCreate":"featured-carousel_buttonCreate__1_J0R"};